import { useEffect, useState } from "react";
import TextShortener from "../TextShortener";
import { Timestamp, collection, doc, getDoc, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
import db from "../Backend";
import { getSavedDocIDs, initDB, saveDocIDs } from "../ConfigureIndexedDB";
import { useNavigate, useParams } from "react-router-dom";
import TestimonyCommentList from "./TestimonyCommentList";


const SharedTestimony = () => {

    const [commentText,setCommentText]=useState("");
    const [showCommentArea,setShowCommentArea]=useState(false);
    const [commenterName,setCommenterName]=useState("");
    const [commentplaceholder,setPlaceholder]=useState("write your comment here");
    const [testimonyShared,setTestimonyShared]=useState(null);
    const [commentDocs,setCommentDocs]=useState([]);
    const [markasRead,setReads]=useState([]);
    const {id} = useParams();
    const navigate = useNavigate();
  
    const [isRead,setIsRead]=useState(false);
    const now = Timestamp.now();
    const comment_timestamp = new Date().getTime(); 
    const commentID = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
    const commentdate = new Date(now?.toDate()).toUTCString();

    useEffect(()=>{
        const doc_ref = doc(db,"testimonyApproved",id);
        getDoc(doc_ref).then((snapshot) =>{
            if(snapshot.exists()){
                setTestimonyShared(snapshot.data());
            }
        }).catch((error)=>{
            console.log(error);
        });
        
    },[id]);

    const USERNAME = testimonyShared && testimonyShared.username && testimonyShared.username;
    const USER_UNIT = testimonyShared && testimonyShared.user_unit && testimonyShared.user_unit;
    const USER_CHAPTER =testimonyShared &&  testimonyShared.user_chapter && testimonyShared.user_chapter;
    const TEXT_TESTIMONY =testimonyShared &&  testimonyShared.testimony && testimonyShared.testimony;
    const DISPLAYPic =testimonyShared && testimonyShared.displaypic && testimonyShared.displaypic;
    const DATE_SENT =testimonyShared && testimonyShared.dateSent && testimonyShared.dateSent;
    const YEARID =testimonyShared && testimonyShared.year && testimonyShared.year;
    const SENDERID =testimonyShared && testimonyShared.senderID && testimonyShared.senderID;

    const handleSendComment=async(e)=>{
        e.preventDefault();
        await setDoc(doc(db,"comments",commentID),{
            commenterName,
            commentText,
            commentdate,
            postID: SENDERID,
            timestamp: comment_timestamp
        });
        setCommentText("");
        setPlaceholder(`God bless you ${commenterName}, Your comment has been sent.`);
        initDB().then(()=>{
            saveDocIDs({
                id: commentID,
                docid: commentID,
            }).catch((err)=>{
                console.log(err);
            })
        }).catch(()=>{

        });
    };

    const handleMarkRead=async(e)=>{
        if(e.target.checked){
            await setDoc(doc(db,"testimoniesRead",commentID),{
                postID: SENDERID,
                timestamp: comment_timestamp
            });
            initDB().then(()=>{
                saveDocIDs({
                    id: SENDERID,
                    docid: commentID,
                    readID: SENDERID
                }).then((res)=>{
                    if(res === true){
                        setIsRead(true);
                    }
                })
                .catch((err)=>{
                    console.log(err);
                })
            }).catch(()=>{

            });
        };
    };

    useEffect(()=>{
        initDB().then(()=>{
            getSavedDocIDs(SENDERID).then((data)=>{
                if(data){
                    if(data.readID === SENDERID){
                        setIsRead(true);
                    }
                }
            }).catch(()=>{

            })
        }).catch(()=>{

        })
    },[SENDERID]);

    useEffect(()=>{
        const collectionref = collection(db,"comments");
        const q = query(collectionref,where("postID","==",SENDERID),orderBy("timestamp","asc"));
        const unsub = onSnapshot(q,(snapshot)=>{
            const firedocs=[];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setCommentDocs(firedocs);
        });
        return unsub;
    },[SENDERID]);

    useEffect(()=>{
        const collectionref = collection(db,"testimoniesRead");
        const q = query(collectionref,where("postID","==",SENDERID),orderBy("timestamp","asc"));
        const unsub = onSnapshot(q,(snapshot)=>{
            const firedocs=[];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setReads(firedocs);
        });
        return unsub;
    },[SENDERID]);

    const goToTestimonyBlog=()=>{
        navigate("/testimonies");
    };
    const shareTestimony=async()=>{
        if(navigator.share){
            try{
                await navigator.share({
                    title: "Testimony",
                    text: `Testimony from ${USERNAME}`,
                    url: `http://localhost:3001/testimonies/${USERNAME}/${SENDERID}`,
                });
            }catch(error){
                console.log(error);
            }
        }else{
            alert("Browser not supported for sharing post, Try using chrome or Safari or Edge browser or simply copy the link from your browser and share.");
        }
    };


    return ( 
        <div className="testimonyblogs2">
        <div className="testimonybody2">
            <div className="testimonyfeed2 flex-column2">
                <div className="testimonyfeedtop flex-row2" style={{width:"100%"}}>
                    <h4 style={{color:"white"}}>
                        {` Life transforming Testimony from ${USERNAME}`}
                    </h4>
                </div>

                    <div className="publishedContents2 flex-column2">
                    <div className="tchead flex-spacebetween" style={{width:"100%"}}>
                        <div className="testifierinfo flex-row2">
                            {DISPLAYPic && DISPLAYPic !== null && DISPLAYPic !=="" ?
                            <img src={DISPLAYPic} alt=""/>
                            :
                            <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            height="30px"
                            width="30px" >
                            <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                            <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                            </svg>
                            }

                            <div className="flex-column2">
                                <h4>{USERNAME && USERNAME}</h4>
                                <p>{DATE_SENT}</p>
                            </div>
                        </div>

                        <p>Unit: {USER_UNIT && USER_UNIT}</p>
                        <p>Chapter: {USER_CHAPTER && USER_CHAPTER}</p>
                        <p>Year: {YEARID}</p>
                    </div>

                    <div className="tctext" style={{width:"100%"}}>
                            {TEXT_TESTIMONY && <TextShortener fullText={TEXT_TESTIMONY} words={200}/>}
                    </div>

                    <div className="tcfooter flex-spacebetween" style={{width:"100%"}}>
                            <div className='tccommenttrigger flex-column2'>
                                {!showCommentArea ? 
                                           <button
                                           onClick={()=>setShowCommentArea(prev => !prev)}
                                           style={{
                                           border:"none",
                                           backgroundColor:"transparent",
                                           cursor:"pointer",
                                           fontWeight:"bold"}}>
                                           Comment
                                           </button>
                                           :
                                           <svg
                                           onClick={()=>setShowCommentArea(prev => !prev)}
                                           cursor="pointer"
                                           viewBox="0 0 24 24"
                                           fill="currentColor"
                                           height="30px"
                                           width="30px">
                                           <path fill="none" d="M0 0h24v24H0z" />
                                           <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                         </svg>
                                }
                                 
                            <p>
                            {commentDocs && commentDocs.length !== 0 && commentDocs.length === 1 ? `${commentDocs.length} comment` :
                           commentDocs.length !== 0 && commentDocs.length > 1 ? `${commentDocs.length} comments` :''}
                            </p>
                        
                            </div>

                            <div className="flex-column2">
                                {isRead ?
                                    <div className="flex-row2">
                                        <svg
                                        viewBox="0 0 24 24"
                                        fill="#0251EB"
                                        height="1em"
                                        width="1em">
                                        <path d="M2.394 13.742l4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084l-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z" />
                                        </svg>
                                    <p>Read</p>
                                    </div>
                                    :
                                    <div className="flex-row2">
                                    <input id={`read${SENDERID}`} type="checkbox" onChange={handleMarkRead}/>
                                    <label htmlFor={`read${SENDERID}`}>Mark as Read</label>
                                    </div>
                                
                                }
                        
                        <p style={{color:"orangered"}}>
                           {markasRead && markasRead.length !== 0 && markasRead.length === 1 ? `${markasRead.length} Read` :
                           markasRead.length !== 0 && markasRead.length > 1 ? `${markasRead.length} Reads` :''}
                        </p>
                            </div>
                        
                        <div className="flex-row2" onClick={shareTestimony} style={{cursor:"pointer"}}>
                            <p>share</p>
                            <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            height="30px"
                            width="30px">
                            <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
                            </svg>
                        </div>
                    </div>

                    {showCommentArea && 
                        <form className="writecommentarea flex-row2">
                        
                            <input type="text" placeholder="your name" required value={commenterName} onChange={e => setCommenterName(e.target.value)}/>
                            <textarea placeholder={commentplaceholder} required rows={5} value={commentText} onChange={e => setCommentText(e.target.value)}/>
                
                            <svg
                            onClick={handleSendComment}
                            cursor="pointer"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            height="30px"
                            width="30px">
                            <path d="M15.854.146a.5.5 0 01.11.54l-5.819 14.547a.75.75 0 01-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 01.124-1.33L15.314.037a.5.5 0 01.54.11zM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493z" />
                            </svg>
                        </form> 
                    }

                    {showCommentArea && 
                        <div className="testimonycommentlist">
                        {commentDocs && commentDocs.map(data=>(
                        <TestimonyCommentList
                        key={data.timestamp}
                        commenterName={data.commenterName}
                        commentText={data.commentText}
                        commentdate={data.commentdate}
                        timestamp={data.timestamp}
                        commentID={data.commentID}
                        />
                        ))}
                        </div>
                    }

                </div>

                <div className="flex-row2" style={{width:"100%"}}>
                        <h4 style={{color:"white"}}> Click here for more 👉</h4>
                        <button style={{border:"none",padding:"10px",borderRadius:"10px",backgroundColor:"white",fontSize:"1.2em",fontWeight:"bold",cursor:"pointer"}}
                        onClick={goToTestimonyBlog}>
                            Testimony Blogs
                        </button>
                </div>

            </div>

        </div>
    </div>

     );
}
export default SharedTestimony;